module.exports = __webpack_public_path__ + "img/AddFeed.6c4f6ac9.png";